module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('span', {
    staticClass: "hidden",
    attrs: {
      "id": "playbackholder"
    }
  }, [_c('span', {
    staticClass: "playback",
    on: {
      "click": _vm.skipback
    }
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "playback",
    on: {
      "click": _vm.togglePause
    }
  }, [_c('i', {
    staticClass: "fa icon-fixed-width fa-pause",
    attrs: {
      "id": "play",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "playback",
    on: {
      "click": _vm.skipfwd
    }
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.datestring))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c05055","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timestamp.vue
// module id = 236
// module chunks = 1